/**
 * 游戏下载指引交互功能
 * 提供游戏下载指引弹窗的显示、隐藏和复制链接功能
 */

/**
 * 初始化游戏下载指引交互功能
 * @return {Object} 包含公共方法的对象
 */
function initDownloadGuide() {
  var $downloadBtns = $('.js-window-download, .js-download-guid');
  var $downloadGuide = $('.game-download-guide');
  var $guideOverlay = $('.guide-overlay');
  var $closeBtn = $('.game-download-guide .guide-close');
  var $copyBtn = $('.game-download-guide .copy-btn');

  // 显示下载指引
  function showDownloadGuide() {
    if ($guideOverlay.length) $guideOverlay.addClass('show');
    if ($downloadGuide.length) {
      $downloadGuide.css('display', 'block');
      setTimeout(function() {
        $downloadGuide.addClass('show');
      }, 10);
    }
  }

  // 隐藏下载指引
  function hideDownloadGuide() {
    if ($guideOverlay.length) $guideOverlay.removeClass('show');
    if ($downloadGuide.length) {
      $downloadGuide.removeClass('show');
      setTimeout(function() {
        $downloadGuide.css('display', 'none');
      }, 500); // 与CSS过渡时间保持一致
    }
  }

  // 复制文本到剪贴板（优先使用现代API，降级到execCommand）
  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function() {
        alert('下载地址已复制到剪贴板');
      }).catch(function() {
        copyFallback(text);
      });
    } else {
      copyFallback(text);
    }
  }

  function copyFallback(text) {
    var $temp = $('<textarea>')
      .css({
        position: 'fixed',
        opacity: 0
      })
      .val(text)
      .appendTo('body');
    var el = $temp.get(0);
    el.select();
    try {
      document.execCommand('copy');
      alert('下载地址已复制到剪贴板');
    } catch (err) {
      console.error('复制失败:', err);
    }
    $temp.remove();
  }

  // 事件绑定
  function bindEvents() {
    if ($downloadBtns.length) {
      $downloadBtns.on('click', function(e) {
        e.preventDefault();
        showDownloadGuide();
      });
    }

    if ($closeBtn.length) {
      $closeBtn.on('click', hideDownloadGuide);
    }

    if ($guideOverlay.length) {
      $guideOverlay.on('click', hideDownloadGuide);
    }

    if ($copyBtn.length) {
      $copyBtn.on('click', function() {
        var downloadUrl = $(this).data('url') || 'https://newgame.17173.com/';
        var spmId = '';
        if (ued && ued.bi && typeof ued.bi.getSpmId === 'function') {
          spmId = ued.bi.getSpmId() + '.mod_mnewgameinfo.0';
        }
        var separator = downloadUrl.includes('?') ? '&' : '?';
        copyToClipboard(downloadUrl + separator + 'spm_id=' + spmId);
      });
    }
  }

  // 初始化
  bindEvents();

  // 返回公共方法
  return {
    show: showDownloadGuide,
    hide: hideDownloadGuide,
    copyToClipboard: copyToClipboard
  };
}

// 导出模块
module.exports = initDownloadGuide;